import { render, staticRenderFns } from "./flowtype-info.vue?vue&type=template&id=4ca8d898&"
import script from "./flowtype-info.vue?vue&type=script&lang=js&"
export * from "./flowtype-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "flowtype-info.vue"
export default component.exports